/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Landing_Finalcta_CopyrightInputs */

const tr_landing_finalcta_copyright = /** @type {(inputs: Landing_Finalcta_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} · Tüm hakları saklıdır.`)
};

const en_landing_finalcta_copyright = /** @type {(inputs: Landing_Finalcta_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} · All rights reserved.`)
};

const de_landing_finalcta_copyright = /** @type {(inputs: Landing_Finalcta_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} · Alle Rechte vorbehalten.`)
};

const ru_landing_finalcta_copyright = /** @type {(inputs: Landing_Finalcta_CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© ${i?.year} · Все права защищены.`)
};

/**
* | output |
* | --- |
* | "© {year} · All rights reserved." |
*
* @param {Landing_Finalcta_CopyrightInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_copyright = /** @type {((inputs: Landing_Finalcta_CopyrightInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_CopyrightInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_copyright(inputs)
	if (locale === "de") return de_landing_finalcta_copyright(inputs)
	if (locale === "ru") return ru_landing_finalcta_copyright(inputs)
	return tr_landing_finalcta_copyright(inputs)
});